import { FlaskConical, Eye, Wrench, HeartPulse, MoreHorizontal, Wheat, type LucideIcon } from "lucide-react";

/**
 * Single source of truth for planner task-type icons.
 *
 * Each task type maps to a lucide glyph + a solid brand colour. The intended
 * presentation is a SOLID colour tile with a WHITE icon on top (same look as the
 * Configuración / Panel Principal cards) — use {@link taskTypeTileShadow} for the
 * matching shadow. Used by the task detail pop-up and the planner task lists.
 */
export interface TaskTypeIconStyle {
  Icon: LucideIcon;
  /** Solid background hex for the tile. */
  color: string;
}

const TASK_TYPE_ICON: Record<string, TaskTypeIconStyle> = {
  treatment:   { Icon: FlaskConical,   color: "#6366F1" }, // Tratamiento
  monitoring:  { Icon: Eye,            color: "#2B7DE0" }, // Monitoreo
  scouting:    { Icon: Eye,            color: "#2B7DE0" }, // Muestreo (monitoreo de plagas)
  maintenance: { Icon: Wrench,         color: "#E0962E" }, // Mantenimiento
  visit:       { Icon: HeartPulse,     color: "#0FA9B8" }, // Visita
  inspection:  { Icon: HeartPulse,     color: "#10A88F" }, // Inspección
  harvest:     { Icon: Wheat,          color: "#16A34A" }, // Cosecha
  other:       { Icon: MoreHorizontal, color: "#647E96" }, // Otro
};

export function getTaskTypeIcon(type: string | null | undefined): TaskTypeIconStyle {
  return TASK_TYPE_ICON[(type || "").toLowerCase()] || TASK_TYPE_ICON.other;
}

/** Colored drop-shadow + inner highlight for the solid tile (matches the card style). */
export function taskTypeTileShadow(color: string): string {
  return `0 6px 14px ${color}42, inset 0 1px 0 rgba(255,255,255,0.28)`;
}
